define((require) => {
    "use strict";

    const ImageWidgetModel = require("shared/ui/experience/widgets/imageWidget/ImageWidgetModel");
    const ImprovedModel    = require("shared/zbone/ImprovedModel");
    const UrlUtil          = require("shared/util/UrlUtil");

    const DEFAULT_COLOR = "#ffffff";
    const BackdropOptions = {
        Fit: {
            EXPERIENCE: "Experience",
            CONTAINER: "Container"
        },
        Type: {
            COLOR: "Color",
            IMAGE: "Image"
        }
    };

    /**
     * Model for the experience backdrop.
     *
     * @class Backdrop
     * @constructor
     */
    return ImprovedModel.extend("Backdrop", {

        defaults: {
            fit: BackdropOptions.Fit.EXPERIENCE,
            type: BackdropOptions.Type.COLOR,
            // Default to null, so we know we need to do backward compatibility check in the getColor method.
            color: null,
            image: null
        },

        /**
         * Check whether the backdrop should fit to container.
         *
         * @returns {Boolean} True if the backdrop fits to container, false otherwise.
         */
        isFitContainer() {
            return this.get("fit") === BackdropOptions.Fit.CONTAINER;
        },

        /**
         * Check whether the backdrop is type of image.
         *
         * @returns {Boolean} True if the backdrop type is an image, false .
         */
        isTypeImage() {
            return this.get("type") === BackdropOptions.Type.IMAGE;
        },

        /**
         * Check whether the background color is transparent or not
         *
         * @returns {Boolean} True if the backdrop color is transparent, false otherwise.
         */
        isTransparent() {
            return this.getColor() === "transparent";
        },

        /**
         * Get the backdrop color. Fallback to the old background color if no color has been set
         *
         * @returns {String} color  A color value in either format "#xxxxxx" or "transparent".
         * @see {@link  BackdropView#initialize}
         */
        getColor() {
            let color = this.get("color");

            if (!color) {
                // A hack to get the old background color. The experience is from backbone.association reverse relation
                color = this.experience.get("backgroundScene").get("backgroundColor") || DEFAULT_COLOR;
            }

            return color;
        },

        /**
         * Get the absolute url of backdrop image.
         *
         * @returns {String} The image url or undefined if there is no image.
         */
        getImageURL() {
            const image = this.get("image");

            if (image) {
                return UrlUtil.getAbsoluteViewerApiUrl(image.url);
            }
        },

        /**
         * Create a mock/temporary <tt>ImageWidgetModel</tt> instance that can be fed to the <tt>ImageURLProvider</tt> to get the resized image url.
         *
         * @returns {ImageWidgetModel} The <tt>ImageWidgetModel</tt> instance.
         */
        getMockModel() {
            const {supportsResize, width, height} = this.get("image");

            return new ImageWidgetModel({
                supportsResize,
                src:                 this.getImageURL(),
                originalImageWidth:  width,
                originalImageHeight: height
            });
        }
    }, {
        TYPE: BackdropOptions.Type,
        FIT: BackdropOptions.Fit
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/Backdrop.js